module.exports = __webpack_public_path__ + "static/media/profile-header.5c15e00d.jpg";